import { createFileRoute, redirect } from '@tanstack/react-router'
import type { Client } from '@/modules/shared/types'

export const Route = createFileRoute('/$orgSlug/$clientSlug/')({
  beforeLoad: ({ params, context }) => {
    // Land un-onboarded stores (prospects, fresh, not-yet-connected) in the
    // Scenario Planner — it needs no connected data and is always available.
    // Onboarded stores go to their Shop Analytics dashboard.
    const { client } = context as { client: Client }
    const to =
      client.onboardingStatus === 'active'
        ? '/$orgSlug/$clientSlug/shop'
        : '/$orgSlug/$clientSlug/scenarios'
    throw redirect({ to, params })
  },
})
